import { useState } from "react";
import { statusLabel, fmtDate, STATUS_COLOR } from "./constants";
import { DetailModal, TrackingPanel, InteractionForm, InteractionsList, HistoryList } from "./DetailShared";

export function CandidateDetail({ id, data, onClose, onChanged, onOpenOffer }) {
  const [tab, setTab] = useState("infos");
  const cv = data.cv || {};
  return (
    <DetailModal testid="candidate-detail" title={data.info.name} subtitle={`${data.info.email} · ${data.info.nexa_id || ""}`}
      onClose={onClose} activeTab={tab} setActiveTab={setTab}
      tabs={[["infos", "Profil & CV"], ["candidatures", `Candidatures (${data.applications.length})`],
             ["interactions", `Historique (${data.interactions.length})`], ["suivi", "Suivi & statuts"]]}>
      {tab === "infos" && (
        <div data-testid="candidate-tab-infos" className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
          {[
            ["Profession", cv.profession || "—"], ["Pays / Ville", [cv.country, cv.city].filter(Boolean).join(" / ") || "—"],
            ["Expérience", cv.experience_years ? `${cv.experience_years} an(s)` : "—"],
            ["Formation", cv.education || "—"], ["Langues", (cv.languages || []).join(", ") || "—"],
            ["Français / Anglais", [cv.french_level, cv.english_level].filter(Boolean).join(" / ") || "—"],
            ["Disponibilité", cv.availability || "—"], ["Mobilité", cv.mobility || "—"],
            ["Destinations", (cv.desired_countries || []).join(", ") || "—"],
            ["Compétences", (cv.skills || []).slice(0, 8).join(", ") || "—"],
            ["Codes CNP", (cv.noc_codes || []).join(", ") || "—"],
            ["Inscription", fmtDate(data.info.created_at)],
          ].map(([k, v]) => (
            <div key={k} className="bg-slate-50 rounded-lg p-3"><p className="text-xs text-slate-500">{k}</p><p className="font-medium text-brand-navy break-words">{v}</p></div>
          ))}
        </div>
      )}
      {tab === "candidatures" && (
        <div data-testid="candidate-tab-candidatures" className="space-y-2 max-h-80 overflow-y-auto">
          {data.applications.length === 0 && <p className="text-sm text-slate-400 text-center py-6">Aucune candidature envoyée.</p>}
          {data.applications.map((a) => (
            <button key={a.application_id} data-testid={`candidate-application-${a.application_id}`} onClick={() => onOpenOffer(a.offer_id)}
              className="w-full text-left border border-slate-100 rounded-lg px-4 py-3 hover:border-brand-turquoise transition-colors flex items-center justify-between gap-3">
              <div>
                <p className="font-medium text-brand-navy text-sm">{a.offer_title}</p>
                <p className="text-xs text-slate-500">{a.company} · {fmtDate(a.created_at)}</p>
              </div>
              <span className={`text-xs font-medium rounded-full px-2.5 py-1 ${STATUS_COLOR(a.status)}`}>{statusLabel(a.status, "candidate")}</span>
            </button>
          ))}
        </div>
      )}
      {tab === "interactions" && (
        <div data-testid="candidate-tab-interactions">
          <InteractionForm testid="candidate" entityType="candidate" entityId={id} onAdded={onChanged} />
          <InteractionsList testid="candidate" interactions={data.interactions} />
        </div>
      )}
      {tab === "suivi" && (
        <div data-testid="candidate-tab-suivi" className="space-y-4">
          <TrackingPanel testid="candidate" entityType="candidate" entityId={id}
            tracking={data.tracking} statuses={data.statuses} kind="candidate" onChanged={onChanged} />
          <HistoryList testid="candidate" history={data.status_history} kind="candidate" />
        </div>
      )}
    </DetailModal>
  );
}
